import { z } from "zod";

export const UserSchema = z.object({
  id: z.string().min(1),
  email: z.string().email(),
  name: z.string().nullable(),
  activeHouseholdId: z.string().nullable(),
});
export type User = z.infer<typeof UserSchema>;
